import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1" });

export const CompanyService = {
  getCompanyList: (filters) => {
    const params = buildQueryParams(filters);
    return api.get(`/companies?${params.toString()}`);
  },

  getCompanyDetails: (companyId) => {
    return api.get(`/companies/${companyId}`);
  },

  createCompany: (companyDetails) => {
    return api.post("/companies", companyDetails);
  },

  updateCompany: (id, payload) => {
    return api.put(`/companies/${id}`, payload);
  },

  deleteCompany: (id) => {
    return api.delete(`/companies/${id}`);
  },

  uploadLogo: ({ id, payload }) => {
    return api.patch(`/companies/${id}/logo`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  /**
   * @param {{id: number, isActive: boolean}} params
   * @returns {Promise<AxiosResponse<any, any>>}
   */
  toggleCompanyActivation: ({ id, isActive }) => {
    return api.put(`${id}`, { active: isActive });
  },

  getCompanySummary: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/analytics/companies/summary?${params.toString()}`);
  },
};
